import BaseComponent from "../../../../baseComponent.js";
import React from "react";

import InternalEvent from "../../../../../core/constants/internalEvent.js";
import ColorUtil from "../../../../../core/utils/colorUtil.js";
import styles from "./styles.scss";

export default class IndividualLegend extends BaseComponent {
  constructor(props) {
    super(props);

    this.subscribe('stale_data_check', payload => this.checkStaleData(payload));
    this.isStale = false;
  }

  handleClick(event) {
    if (event.target === this.refs.editIcon) {
      this.publish('openLegendConfig', {
        widgetId: this.props.widgetId,
        legends: [this.props.legend]
      });
    } else {

      this.publish(InternalEvent.Dashboard.CHART_LEGEND_CLICKED, {
        widgetId: this.props.widgetId,
        legends: [this.props.legend]
      });
    }
  }

  handleMouseEnter() {
    this.publish(InternalEvent.Dashboard.CHART_LEGEND_HOVERED, {
      widgetId: this.props.widgetId,
      legends: [this.props.legend]
    });
  }

  handleMouseLeave() {
    this.publish(InternalEvent.Dashboard.CHART_LEGEND_HOVERED, {widgetId: this.props.widgetId, legends: []});
  }

  checkStaleData(payload) {
    if (payload.widgetId === this.props.widgetId && payload.legendId === this.props.legend.id) {
      if (payload.isStale && !this.isStale) {
        $(this.refs.label).css("text-decoration", "line-through");
        this.isStale = true;
      }

      if (!payload.isStale && this.isStale) {
        $(this.refs.label).css("text-decoration", "none");
        this.isStale = false;
      }
    }
  }

  render() {
    let bgColor = ColorUtil.toRgba(this.props.legend.parameters.legendColor,
      this.props.legend.parameters.chartTypeParameters.fillOpacity);
    let borderColor = this.props.legend.parameters.legendColor;

    let colorStyle = {
      float: 'left',
      width: '11px',
      height: '11px',
      background: bgColor,
      border: "1px solid " + borderColor,
      borderRadius: "10px",
      marginTop: "1px"
    };

    let style = {};
    if (!this.props.legend.parameters.isActive) style["opacity"] = "0.5";

    return (
      <div className={styles.legend} style={style} onMouseEnter={this.handleMouseEnter}
           onMouseLeave={this.handleMouseLeave}
           onClick={this.handleClick}
           ref="container">
        <div ref="legendEditContainer" style={{zIndex: 11000}}/>
        <div style={colorStyle}/>
        <div className={styles.label} ref="label">
          {this.props.evalLegendLabel(this.props.legend.parameters.legendLabel)}
        </div>
        <i className="icon-note" ref="editIcon"/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/legend/individualLegend.jsx